import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import { formatVersion } from '../utils/version';

interface UpdateNotificationProps {
  show: boolean;
  onRefresh: () => void;
  onClose: () => void;
  isUpdating?: boolean;
  currentVersion?: string;
  availableVersion?: string;
}

import { useTranslation } from '../i18n/translations';

const UpdateNotification: React.FC<UpdateNotificationProps> = ({ 
  show, 
  onRefresh, 
  onClose,
  isUpdating = false,
  currentVersion,
  availableVersion
}) => {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {show && (
        <div className="update-overlay">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className={`update-card glass ${isUpdating ? 'updating' : ''}`}
          >
            <div className="update-mascot-container">
              <img 
                src="/branding/update-mascot.webp" 
                alt="Update N-Bot" 
                className="update-mascot-img"
              />
            </div>

            <div className="update-content">
              <div className="update-text-group">
                <h2 className="update-title">
                  {isUpdating ? t('UPDATING') : t('UPDATE_AVAILABLE')}
                </h2>
                <p className="update-desc">
                  {isUpdating ? t('UPDATE_PREPARING') : t('UPDATE_READY')}
                </p>
                {(currentVersion || availableVersion) && (
                  <div className="update-version-tag">
                    <span className="v-label">v{formatVersion(currentVersion)}</span>
                    <span className="v-arrow">→</span>
                    <span className="v-label highlight">v{formatVersion(availableVersion)}</span>
                  </div>
                )}
              </div>
            </div>
            
            <div className="update-actions">
              {!isUpdating ? (
                <>
                  <button onClick={onRefresh} className="update-btn-refresh">
                    {t('REFRESH_NOW')}
                  </button>
                  <button onClick={onClose} className="update-btn-close-text">
                    {t('LATER')}
                  </button>
                </>
              ) : (
                <div className="update-loading-dots" style={{ transform: 'scale(1.2)' }}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              )}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default UpdateNotification;
